<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <MainTournamentTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import MainTournamentTable from './MainTournament/MainTournamentTable.vue'

  export default {
    name: 'main-tournament-table',
    components: {MainTournamentTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/tournament/MainTournament.vue